import { SansTitle } from '../SansTitle/SansTitle'
import type { CartTitleProps } from './CartTitle.types'

export const CartTitle = ({ title }: CartTitleProps): JSX.Element => {
  return (
    <SansTitle
      as="h2"
      size="xs"
      fontWeight="600"
      style={{ paddingBottom: '1rem' }}
    >
      {title}
    </SansTitle>
  )
}
